module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/PaperSourceWeddingBanner-bac945d52f3793f3a7d50259d6496818.png";